import { render, staticRenderFns } from "./CoursesFilters.vue?vue&type=template&id=3a845bc8&"
import script from "./CoursesFilters.vue?vue&type=script&lang=js&"
export * from "./CoursesFilters.vue?vue&type=script&lang=js&"
import style0 from "./CoursesFilters.vue?vue&type=style&index=0&id=3a845bc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports